import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div style={{ minHeight: '100vh', background: '#F4F6F9' }}>
      <div className="privacy-policy" style={{
        maxWidth: '760px',
        margin: '0 auto',
        padding: '48px 24px',
        lineHeight: 1.6,
        color: '#334155',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
      }}>
        <h1 style={{ fontSize: '2rem', marginBottom: '0.25rem', color: '#0f172a', fontWeight: 700 }}>Privacy Policy</h1>
        <p style={{ color: '#64748b', marginBottom: '2rem' }}>Last updated: July 14, 2026</p>

        <p>
          Snow Logik, LLC ("Snow Logik," "we," "us," or "our") operates snowlogik.com
          and the Snow Logik app (the "Service"). This Privacy Policy explains what
          information we collect, how we use it, and the choices you have.
          By using Snow Logik, you agree to the practices described here.
        </p>

        <h2 style={sectionStyle}>1. Information We Collect</h2>
        <p><strong>Account information.</strong> If you create an account, we collect
        your email address and a securely hashed password via our authentication
        provider, Supabase.</p>
        <p><strong>Saved places.</strong> If you save locations for forecasting, we
        store the location data and associate it with your account.</p>
        <p><strong>Waitlist signups.</strong> If you join our waitlist, we store the
        email address you provide.</p>
        <p><strong>Payment information.</strong> If you subscribe to Snow Logik Pro,
        payment is processed by Stripe. We do not collect or store your full card
        details ourselves &mdash; Stripe shares limited subscription status data
        (such as plan type and renewal date) with us so we can enable Pro features
        on your account.</p>
        <p><strong>Usage &amp; device data.</strong> Like most websites, we may
        automatically collect basic technical data (browser type, device type,
        general location inferred from IP, pages visited) to keep the Service
        running reliably and secure.</p>

        <h2 style={sectionStyle}>2. How We Use Your Information</h2>
        <ul>
          <li>To provide and operate the Service, including forecasts, saved places, and account features</li>
          <li>To process payments and manage Pro subscriptions</li>
          <li>To send account-related emails (confirmation, password reset, receipts) and, if you opt in, powder alerts</li>
          <li>To maintain the security, integrity, and performance of the Service</li>
          <li>To improve Snow Logik based on how it's used</li>
        </ul>

        <h2 style={sectionStyle}>3. Third-Party Services</h2>
        <p>We rely on trusted third-party providers to run Snow Logik. Each processes
        data under its own privacy policy:</p>
        <ul>
          <li><strong>Supabase</strong> &mdash; authentication and database hosting</li>
          <li><strong>Stripe</strong> &mdash; payment processing</li>
          <li><strong>Mapbox</strong> &mdash; interactive map rendering</li>
          <li><strong>Open-Meteo</strong> &mdash; weather and snowfall data (no personal data shared)</li>
          <li><strong>Resend</strong> &mdash; transactional email delivery</li>
          <li><strong>Cloudflare</strong> &mdash; DNS and email routing</li>
          <li><strong>Vercel</strong> &mdash; site hosting</li>
        </ul>

        <h2 style={sectionStyle}>4. Cookies &amp; Advertising</h2>
        <p>Snow Logik may use cookies and similar technologies to keep you signed in,
        remember preferences, and understand how the Service is used.</p>
        <p>We may display ads through Google AdSense. Google and its partners may use
        cookies (including the DoubleClick cookie) to serve ads based on your prior
        visits to this and other websites. You can opt out of personalized
        advertising by visiting Google's Ads Settings at
        www.google.com/settings/ads, or generally at
        www.aboutads.info if you'd like to opt out of third-party vendors' use of
        cookies for personalized advertising.</p>

        <h2 style={sectionStyle}>5. Data Retention</h2>
        <p>We retain account and saved-places data for as long as your account is
        active. You may request deletion of your account and associated data at
        any time by contacting us.</p>

        <h2 style={sectionStyle}>6. Your Rights</h2>
        <p>You may access, update, or delete your saved places at any time within
        the app. To request full account deletion or a copy of your data, email
        us at the address below.</p>

        <h2 style={sectionStyle}>7. Children's Privacy</h2>
        <p>Snow Logik is not directed to children under 13, and we do not knowingly
        collect personal information from children under 13.</p>

        <h2 style={sectionStyle}>8. Security</h2>
        <p>We use industry-standard measures, including encrypted data storage and
        transmission, to protect your information. No method of transmission or
        storage is 100% secure, and we can't guarantee absolute security.</p>

        <h2 style={sectionStyle}>9. Changes to This Policy</h2>
        <p>We may update this Privacy Policy from time to time. Changes will be
        posted on this page with an updated "Last updated" date.</p>

        <h2 style={sectionStyle}>10. Contact Us</h2>
        <p>Questions about this policy? Reach us at{' '}
        <a href="mailto:ethan@snowlogik.com" style={{ color: '#185FA5' }}>
          ethan@snowlogik.com
        </a>.</p>

        <p style={{ marginTop: '2.5rem' }}>
          <a href="/" style={{ color: '#185FA5', fontSize: '0.9rem' }}>&larr; Back to Snow Logik</a>
        </p>
      </div>
    </div>
  );
}

const sectionStyle = {
  fontSize: '1.25rem',
  marginTop: '2rem',
  marginBottom: '0.5rem',
  color: '#0f172a',
  fontWeight: 600
};
